export const searchModes = {
    BUNDLED: 'BUNDLED',
    FULL: 'FULL',
};
